import { render, staticRenderFns } from "./view-pharmacy-orders-delivery-details-new.vue?vue&type=template&id=c3e88782"
import script from "./view-pharmacy-orders-delivery-details-new.vue?vue&type=script&lang=js"
export * from "./view-pharmacy-orders-delivery-details-new.vue?vue&type=script&lang=js"
import style0 from "./view-pharmacy-orders-delivery-details-new.vue?vue&type=style&index=0&id=c3e88782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports